import React, { useEffect, useRef, useState } from 'react'
import './index.less'
import copyToClipboard from '../../utils/copyTo';
import { Breadcrumb } from '@ezviz/ezd';
import { useHistory } from 'react-router-dom'

import hljs from 'highlight.js';
import 'highlight.js/styles/a11y-dark.css'


let REG_TEXT = new RegExp('<(h1|h2)[^>]*>.*?<\/\\1>', 'g');
let REG_TAG = new RegExp('<(\/?)(\\w+)');
let REG_PRE = new RegExp('<(pre)>[^]*?<\/\\1>', 'g');
let REG_CODE = new RegExp('<code[^]*?<\/code>', 'g');

function debounce(func, wait) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            func.apply(context, args);
        }, wait);
    };
}

const DocContent = (props) => {

    const history = useHistory()

    let { htmlString, BreadData } = props


    // 渲染的html string
    const [ht, setHt] = useState(null)


    /**  收集右侧标签 */
    const list = useRef([])
    const [active, setActive] = useState({})


    const getDomStr = (htmlStr) => {
        if (htmlStr) {
            //  拿到html模板
            let matchedTags = htmlStr.match(REG_TEXT);
            let arr = []
            if (matchedTags) {
                arr = matchedTags.map(e => ({ type: getTag(e), text: getText(e) }));
            }
            list.current = arr
        }
    }
    // 拿到dom中的文字
    const getText = (_) => {
        return _ ? _.replace(/<[^>]+>/g, '') : null
    }
    // 拿到tag
    const getTag = (_) => {
        return _.match(REG_TAG) ? _.match(REG_TAG)[2] : null
    }
    useEffect(() => {
        // 偶现 不变量 不能正常赋值
        list.current = []
        getDomStr(htmlString)
        getPRE(htmlString)
    }, [htmlString])
    /** 收集h1 标签 */
    const getHASH = () => {
        let content = document.getElementById("content")
        const scrollHandler = debounce(function () {
            const h1 = content.getElementsByTagName("h1")
            const h2 = content.getElementsByTagName("h2")
            if (h1.length > 0 || h2.length > 0) {
                //  屏幕最上方为分界线  min 为下方   max 为上方
                let min = Number.MAX_SAFE_INTEGER
                let minText = null
                let max = Number.MIN_SAFE_INTEGER
                let maxText = null
                const getBoundingClientRect = (e) => {
                    let { top } = e.getBoundingClientRect()
                    if (top >= 0) {
                        min = Math.min(min, top)
                        if (min == top) {
                            minText = e.innerHTML
                        }
                    } else {
                        max = Math.max(max, top)
                        if (max == top) {
                            maxText = e.innerHTML
                        }
                    }
                }
                for (const element of h1) {
                    getBoundingClientRect(element)
                }
                for (const element of h2) {
                    getBoundingClientRect(element)
                }
                // console.log(min, minText, max, maxText);
                const getIndex = (text) => {
                    let index = list.current.findIndex(item => item.text == text)
                    if (index + 1) {
                        setActive({ text, index })
                    }
                }

                if (min > (window.innerHeight)) { // /2 半屏以上收集
                    // BUG 保留打印 B2 删除
                    console.log("找到屏幕上方的", max, maxText);
                    getIndex(getText(maxText))
                } else if (minText) {
                    console.log("找到屏幕下方的", min, minText);
                    getIndex(getText(minText))
                } else {
                    console.log("找到屏幕上方的", max, maxText);
                    getIndex(getText(maxText))
                }
            }
        }, 100);



        scrollHandler()
        window.addEventListener("scroll", scrollHandler, true)

    }


    /** 收集代码块 */
    const getPRE = (htmlStr) => {
        if (htmlStr) {
            let res = htmlStr.match(REG_PRE)
            let newhmtl = htmlStr
            if (res) {
                res.forEach(e => {
                    newhmtl = newhmtl.replace(e, dom(e))
                });
            }

            let res2 = htmlStr.match(REG_TEXT)
            let temp = document.createElement("temp")
            if (res2) {
                res2.forEach(e => {
                    console.log(e);
                    temp.innerHTML = e
                    let a = temp.children[0]
                    a.setAttribute("id", getText(e))
                    newhmtl = newhmtl.replace(e, a.outerHTML)
                });
            }

            setHt(newhmtl)
        }
    }
    const dom = (element) => {
        // frm 不能保持原有结构  效率一致
        // let frm = document.createDocumentFragment("")
        // frm.appendChild(document.createElement(pro))
        let pre = document.createElement("pre")
        let codeTag = document.createElement("code")
        let code = element.match(REG_CODE)[0]// dom化的同时  保持原有结构
        code = code.replaceAll("&quot;", '"')
        code = code.replaceAll("&lt;", '<')
        code = code.replaceAll("&gt;", '>')
        code = code.replace(/<\/?code[^>]*>/g, "").trim();

        const highlightedCode = hljs.highlightAuto(code).value;
        codeTag.innerHTML = highlightedCode
        pre.appendChild(codeTag)
        let action = document.createElement("div")
        action.innerHTML = '<svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 viewBox="0 0 15.5 16" style="enable-background:new 0 0 15.5 16;" xml:space="preserve"><style type="text/css">	.st0{opacity:0;}	.st1{fill:#FFFFFF;}	.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}</style><g id="矩形_5" class="st0">	<path class="st1" d="M2.6,4.3h8c0.6,0,1,0.4,1,1v8c0,0.6-0.4,1-1,1h-8c-0.6,0-1-0.4-1-1v-8C1.6,4.8,2,4.3,2.6,4.3z"/></g><g id="矩形_5_00000051342396541499952430000018202296876109310353_">	<path class="st1" d="M10.1,14.3h-7c-0.8,0-1.5-0.7-1.5-1.5v-7c0-0.8,0.7-1.5,1.5-1.5h7c0.8,0,1.5,0.7,1.5,1.5v7		C11.6,13.6,10.9,14.3,10.1,14.3z M3.1,5.3c-0.3,0-0.5,0.2-0.5,0.5v7c0,0.3,0.2,0.5,0.5,0.5h7c0.3,0,0.5-0.2,0.5-0.5v-7		c0-0.3-0.2-0.5-0.5-0.5H3.1z"/></g><g id="矩形_6">	<path class="st2" d="M3,4.8V3.3c0-0.2,0-0.4,0.1-0.6c0.1-0.2,0.2-0.3,0.3-0.5S3.8,2,4,1.9c0.2-0.1,0.4-0.1,0.6-0.1h8		c0.2,0,0.4,0,0.6,0.1c0.2,0.1,0.3,0.2,0.5,0.3c0.1,0.1,0.2,0.3,0.3,0.5c0.1,0.2,0.1,0.4,0.1,0.6v8c0,0.2,0,0.4-0.1,0.6		c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.1-0.3,0.2-0.5,0.3c-0.2,0.1-0.4,0.1-0.6,0.1h-1.5v-1h1.5c0.1,0,0.3,0,0.4-0.1		c0.1-0.1,0.1-0.2,0.1-0.4v-8c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.1-0.2-0.1-0.4-0.1h-8c-0.1,0-0.2,0-0.4,0.1C4.1,3,4.1,3.2,4.1,3.3v1.5H3		z"/></g><g id="矩形_7">	<rect x="4.1" y="7.6" class="st1" width="3" height="1"/></g><g id="矩形_8">	<rect x="4.1" y="10" class="st1" width="5" height="1"/></g></svg>'
        action.setAttribute("class", "copy")

        action.setAttribute("code", code)

        pre.appendChild(action)
        return pre.outerHTML

    }

    useEffect(() => {
        let doms = document.getElementsByClassName("copy")
        const clickHandle = (e) => {
            copyToClipboard(e.currentTarget.getAttribute("code"))
        }
        if (doms) {
            for (const dom of doms) {
                dom.addEventListener("click", clickHandle, { capture: true })
            }
            getHASH()
        }



        return () => {
            if (doms) {
                for (const dom of doms) {
                    dom.removeEventListener("click", clickHandle)
                }
            }
        }
    }, [ht])



    const [tag, setTag] = useState(true)
    useEffect(() => {
        if (window.location.hash && tag) {
            let hash = window.location.hash.slice(1)
            hash = decodeURIComponent(hash)
            // decodeURIComponent  
            let el = document.getElementById(hash);
            if (el) {
                setTimeout(() => {
                    let top = 0
                    if (document.getElementById("main-nav").style.position != "fixed") {
                        top = 60
                    }
                    window.scrollTo(0, el.offsetTop - top);
                    setTag(false)
                }, 100);
            }
        } else {
            // window.scrollTo(0, 0);
        }

    });

    useEffect(() => {
        let scrollHandler = function () {
            let el = document.getElementById("right-list")
            let eld = document.getElementById("list")
            let foot = document.getElementById("cn-open-footer") || null // dom 在其他组件中可能中
            let mainNav = document.getElementById("main-nav") || null // dom 在其他组件中可能中
            let leftNav = document.getElementById("left-nav") || null // dom 在其他组件中可能中

            let top = 0

            if (el) {
                //  防抖在设置定位属性上效果不好   添加判断是否需要修改定位属性  减少 dom 样式操作   加了功能后这个操作毫无意义了
                if (el.getBoundingClientRect().top <= 60) {
                    eld.style.position = "fixed"
                    leftNav.style.position = "fixed"
                    top = 60
                }
                if (mainNav.getBoundingClientRect().top <= 0) {
                    mainNav.style.position = "fixed"
                }
                if (el.getBoundingClientRect().top > 60 && eld.style.position != "relative") {
                    eld.style.position = "relative"
                    mainNav.style.position = "relative"
                    leftNav.style.position = "relative"
                }

                // aly 的 解决方案
                if (foot) {
                    let rect = foot.getBoundingClientRect();
                    let elTopToWindowBottom = window.innerHeight - rect.top;
                    if (elTopToWindowBottom > 0) {
                        top = 60 - elTopToWindowBottom
                    }
                }

                leftNav.style.top = top + "px"
                eld.style.top = top + "px"
            }
        }

        window.addEventListener("scroll", scrollHandler, true)
        return () => {
            window.removeEventListener("scroll", scrollHandler)
        }
    }, [])

    return (
        <div className="doc-content">
            <div className="custom-html-style">
                <Breadcrumb>
                    {BreadData.map((item, index) =>
                        <Breadcrumb.Item
                            // onClick={() => {
                            //     // 点菜单没有效果
                            //     if (item.docId && item.docId.length != 32) {
                            //         if (index == BreadData.length - 1) {
                            //             window.location.reload()
                            //         }
                            //         history.push("/help/" + item.docId);
                            //     }
                            // }}
                            key={item.text}
                        >
                            {item.text}
                        </Breadcrumb.Item>
                    )}
                </Breadcrumb>
                <div
                    id="content"
                    dangerouslySetInnerHTML={{ __html: ht }}
                    style={{ paddingTop: "15px", marginBottom: "100px" }}
                ></div>
            </div>
            <div className="right-list" id="right-list">
                <div className="list" id="list">

                    {list.current.length > 0 && (
                        <>
                            {list.current.map((i,index) => (
                                <div
                                    className={[
                                        "title",
                                        i.type == "h2" ? "sub-title" : "",
                                        active.text == i.text ? "active" : "",
                                    ].join(" ")}
                                    key={index}
                                    onClick={() => {
                                        let top = 0
                                        if (document.getElementById("main-nav").style.position != "fixed") {
                                            top = 60
                                        }
                                        let element = document.getElementById(i.text);
                                        let elementPosition = element.offsetTop - top;
                                        window.scrollTo({ top: elementPosition, behavior: 'smooth' });
                                    }}
                                >
                                    {i.text}
                                </div>
                            ))}
                            <div
                                className="after"
                                style={{ top: 25 + active.index * 35 + "px" }}
                            >
                            </div>
                        </>

                    )}
                </div>
            </div>



        </div>
    );
}

export default DocContent;